import styled from "styled-components";

export const ExploreTableContainer = styled.div`
  @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
    width: 100%;
  }

  table {
    th {
      text-transform: capitalize;
    }
  }
`;

export const TableTitleContainer = styled.div`
  display: flex;
  align-items: center;
  border: none;

  width: 100%;

  padding: 0.75rem 0;

  span {
    font-size: ${(props) => props.theme.fontSize.SM};
    font-weight: ${(props) => props.theme.fontWeight.Semibold};
    color: ${(props) => props.theme.colors["black-925"]};
  }

  div {
    span {
      font-size: ${(props) => props.theme.fontSize.XXS};
      margin-right: 0.5rem;
    }

    input {
      font-size: ${(props) => props.theme.fontSize.Nano};

      border: 1px solid ${(props) => props.theme.colors["gray-400"]};
      border-radius: 0.5rem;

      padding: 6px;
      width: 3rem;
      height: 2rem;
    }

    @media (max-width: ${(props) => props.theme.responsiveDesign.sm}) {
      padding: 0.25rem 0;
    }
  }
`;

export const TableContainer = styled.div`
  width: 75vw;
  height: 70vh;
  overflow: scroll;
`;
